import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faItalic } from "@fortawesome/free-solid-svg-icons"

export const Italic = (props) => {
  return <FontAwesomeIcon faIcon={faItalic} {...props} />
}
